import {Injectable, Inject} from '@angular/core';
import {Http, Headers, Response, RequestOptions} from '@angular/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import { APP_CONFIG, IAppConfig } from './../app.config';
import 'rxjs/add/observable/throw';

@Injectable()
export class CountryService {
  private _token: string = localStorage.getItem('token');

  constructor(private http: Http, 
    @Inject(APP_CONFIG) private config: IAppConfig)
    { }

  countryList(){
    
    let token = this._token;
    let headers = new Headers({ 'Authorization': token });
    let options = new RequestOptions({ headers: headers });
    console.log(this.config.apiEndpoint);
    return this.http.get(this.config.apiEndpoint + 'countryStore', options).map((res => res.json()))
        .catch(this.handleErrorObservable);

  }

  /* countryList() {
    const token = this._token;
    const headers = new Headers({ 'Authorization': token });
    const options = new RequestOptions({ headers: headers });

    return this.http.get(this.config.apiEndpoint + 'personalinfo/getCountries', options).map((res => res.json()))
        .catch((error: any) => Observable.throw(error.json().error || 'Server error'));
  } */

  private handleErrorObservable (error: Response | any) {
    /*if(!error.json().error){
      alert('Please check your internet connection');
    }*/
    return Observable.throw( error.json().error || 'Server Error' );
  }
}



// WEBPACK FOOTER //
// /home/aschmidt/websites/onefuturecv.org/onefuture-frontend/src/app/_services/country.service.ts